import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../services/feedback.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    templateUrl: './feedback-dialog.component.html',
    styleUrls: ['./feedback-dialog.component.scss'],
    standalone: false
})
export class FeedbackDialogComponent implements OnInit {
  constructor(private feedback: FeedbackService) {}

  ngOnInit(): void {}

  static open(dialog: MatDialog) {
    return dialog.open<FeedbackDialogComponent>(FeedbackDialogComponent, {
      closeOnNavigation: true,
      minWidth: 340,
    });
  }

  sendFeedback(text: string) {
    this.feedback.sendFeedback(0, [text]).subscribe();
  }
}
